import { Stack } from '@mantine/core';
import { FilterStep } from '@/types/automationSteps.ts';
import StepCommonFields from '@/pages/Editor/components/SharedFields/StepCommonFields.tsx';
import SingleDataInputSelector from '@/pages/Editor/components/SharedFields/DataInputSelector/SingleDataInputSelector.tsx';
import FilterFields from '@/pages/Editor/components/StepSidebar/StepForms/FilterStep/FilterFields.tsx';
import OutputNameField from '@/pages/Editor/components/SharedFields/OutputNameField.tsx';
import StepAdvancedConfigFields from '@/pages/Editor/components/SharedFields/StepAdvancedConfigFields.tsx';

type props = {
  step: FilterStep;
};

export function FilterForm({ step }: props) {
  return (
    <Stack gap="md">
      <StepCommonFields step={step} nameLabel={'Step Name'} />
      {/*<Divider />*/}
      <SingleDataInputSelector step={step} />
      {/*<Divider />*/}
      <FilterFields step={step} />
      <OutputNameField step={step} />
      <StepAdvancedConfigFields step={step} />
    </Stack>
  );
}
